const resource = {
    resource_identifier_in_use: 'Идентификатор API {{indicator}} уже используется',
};
export default resource;
